/* eslint-disable no-undef */
window.onmount = require('onmount');

import 'stimulus';

// Turbo runs alongside Turbolinks for the UI-kit pilot. `drive = false` disables
// global click/form interception so Turbolinks keeps handling app-wide navigation;
// only <turbo-frame> and <turbo-stream> activate Turbo. Do not remove this line
// without first migrating off Turbolinks app-wide.
import { Turbo } from '@hotwired/turbo-rails';
Turbo.session.drive = false;
import { initTracking } from 'lib/marketing';
import * as Scripts from 'lib/scripts';
window.Scripts = Scripts;

window.PONG = require('pong.js');

import 'lib/anonymous_footer_hubspot';
import 'lib/anonymous_navbar_menu';
import 'lib/ats_offers';
import 'lib/import_hiring_steps';
initTracking();

require('lib/realtime_notifications').init();
import 'images/icons/project.svg';

require('stylesheets/utils.scss');
import 'components/conversations/chat_functions';

// Wizard
import 'components/post_a_job/wizard/post_wizard';
require('components/post_a_job/wizard/wizard.scss');
import 'components/post_a_job/wizard/sidebar/wizard_sidebar';
import 'components/post_a_job/wizard/wizard_buttons/wizard_buttons';
import 'components/post_a_job/wizard/experience_level_autofill';
import 'components/post_a_job/wizard/title_suggestions';
import 'components/post_a_job/wizard/category_autofill_from_title';
import 'components/post_a_job/contract_type';
import 'components/post_a_job/contract_type.scss';
import 'components/post_a_job/location_details_v2_edit_form';

// Trix Editor
import 'trix/dist/trix.css';
import 'trix';

// Landing.work
import LWIndex from 'landing_work/home/components/index';
import LWEmployers from 'landing_work/home/components/employers';

import {
  loadConstructors,
  loadedConstructor,
  pendingConstructors,
} from 'lib/lazy_react_components';

// For use by CoffeeScript code
import { insertReactElement } from 'lib/react';
import { tagManagerTrack } from 'lib/marketing';
import { scrollToFirstError } from 'lib/scrollToFirstError';
window.insertReactElement = insertReactElement;
window.tagManagerTrack = tagManagerTrack;
window.scrollToFirstError = scrollToFirstError;

document.addEventListener('DOMContentLoaded', function () {
  // Mount React components. This needs to run after Turbolinks has loaded.
  var ReactRailsUJS = require('react_ujs');

  var mountComponentsOriginal = ReactRailsUJS.mountComponents;

  function classNamesToMount(searchSelector) {
    var nodes = ReactRailsUJS.findDOMNodes(searchSelector);

    return Array.prototype.map.call(nodes, function (node) {
      return node.getAttribute(ReactRailsUJS.CLASS_NAME_ATTR);
    });
  }

  function mount(searchSelector) {
    mountComponentsOriginal.call(ReactRailsUJS, searchSelector);
    document.dispatchEvent(new Event('react_rails:mounted'));
  }

  // HACK: override the constructor to inject landing_work components
  ReactRailsUJS.getConstructor = function (className) {
    if (className === 'LWIndex') {
      return LWIndex;
    } else if (className === 'LWEmployers') {
      return LWEmployers;
    } else {
      return loadedConstructor(className);
    }
  };

  // Components arrive in their own chunk, so fetch what this page needs before
  // handing over to react_ujs, which mounts synchronously. Already-loaded
  // components mount in the same tick, as they did with an eager context.
  ReactRailsUJS.mountComponents = function (searchSelector) {
    var pending = pendingConstructors(classNamesToMount(searchSelector));

    if (pending.length === 0) return mount(searchSelector);

    return loadConstructors(pending).then(function () {
      mount(searchSelector);
    });
  };

  // Async lookup for callers that mount a component the page did not declare.
  ReactRailsUJS.loadConstructor = function (className) {
    var constructor = ReactRailsUJS.getConstructor(className);

    if (constructor) return Promise.resolve(constructor);

    return loadConstructors([className]).then(function () {
      return ReactRailsUJS.getConstructor(className);
    });
  };

  document.dispatchEvent(new Event('react_rails:loaded'));
});
